import axios from "../../utils/axios";
import type { UploadFileResponseDTO } from "../types/commonDtos";
import type { RiskAssessmentAttachmentDTO, UploadAttachmentRequest } from "../types/riskAssessmentAttachmentDtos";

const apiUrl = process.env.REACT_APP_HS_API_URL;

// Both levels come back together; the caller splits on riskAssessmentHazardId.
const fetchAttachments = (riskAssessmentId: number) =>
    axios.get<RiskAssessmentAttachmentDTO[]>(`${apiUrl}/RiskAssessment/${riskAssessmentId}/Attachments`);

const uploadAttachments = ({ riskAssessmentId, riskAssessmentHazardId, files, onUploadProgress }: UploadAttachmentRequest) => {
    const formData = new FormData();

    for (const [index, dto] of files.entries()) {
        formData.append(`[${index}].syncId`, dto.syncId);
        formData.append(`[${index}].file`, dto.file);
    }

    const query = riskAssessmentHazardId ? `?riskAssessmentHazardId=${riskAssessmentHazardId}` : "";

    return axios.post<UploadFileResponseDTO[]>(
        `${apiUrl}/RiskAssessment/${riskAssessmentId}/Attachments${query}`,
        formData,
        {
            headers: { "Content-Type": "multipart/form-data" },
            onUploadProgress,
        }
    );
};

const downloadAttachment = (reference: string) =>
    axios.get<ArrayBuffer>(`${apiUrl}/RiskAssessment/Attachment/${reference}`, {
        responseType: "arraybuffer",
    });

const deleteAttachment = (attachmentId: number) =>
    axios.delete<void>(`${apiUrl}/RiskAssessment/Attachment/${attachmentId}`);

const riskAssessmentAttachmentService = {
    fetchAttachments,
    uploadAttachments,
    downloadAttachment,
    deleteAttachment,
};

export default riskAssessmentAttachmentService;
